import { render, staticRenderFns } from "./DashboardGraficoTempoMedio.vue?vue&type=template&id=49b29972&"
import script from "./DashboardGraficoTempoMedio.vue?vue&type=script&lang=js&"
export * from "./DashboardGraficoTempoMedio.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGraficoTempoMedio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer})
